import { render } from "./LbrxQuantityPopup.vue?vue&type=template&id=10e51cbd&scoped=true"
import script from "./LbrxQuantityPopup.vue?vue&type=script&lang=js"
export * from "./LbrxQuantityPopup.vue?vue&type=script&lang=js"

import "./LbrxQuantityPopup.vue?vue&type=style&index=0&id=10e51cbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e51cbd"]])

export default __exports__